<template>
    <v-dialog
      v-model="dialog"
      max-width="1440"
    >
      <v-card v-if="itemType == 'job'">
        <v-card-title class="headline">Job: {{ eventItem.id }}</v-card-title>


            <div outlined class="ma-8 d-flex justify-space-around">
                <v-spacer />
                    <img class="ma-2" v-show="image1" :src="image1" />
                    <img class="ma-2" v-show="image2" :src="image2" />
                <v-spacer />
            </div>
            
            <div align="center">
                <img v-show="resultsImage" :src="resultsImage" />

                <v-spacer />

                <v-btn v-if="resultsCSV" tile color="primary" outlined :href="resultsCSV">
                <v-icon>mdi-download</v-icon>CSV
                </v-btn>
            </div>

            <v-spacer />
            
            <blockquote align="left" class="blockquote ma-4">
                <pre>{{ metadata }}</pre>
            </blockquote>

      </v-card>
      <v-card v-if="itemType == 'contact'">
        <v-card-title class="headline">Contact Us: {{ eventItem.id }}</v-card-title>
          <div class="pa-12">
            <p><b>Name:</b> {{ metadata.name }}</p>
            <p><b>Email:</b> {{ metadata.email }}</p>
            <p>{{ metadata.message }}</p>
          </div>
      </v-card>
    </v-dialog>
</template>


<script>
  export default {
    name: 'EventDetails',
    props: ["eventItem"],
    data: () => ({
      dialog: false,
      itemType: '',
      image1: '',
      image2: '',
      resultsImage: '',
      resultsCSV: '',
      metadata: ''

    }),
    methods: {
      loadMetaData() {
          this.$http
          .get(this.getHost() + 'job/' + this.eventItem.job + "/metadata.json")
          .then(function(data) {
              this.metadata = data.bodyText;
          });
      },
    },
    watch: { 
        eventItem: function(newVal, oldVal) { // watch it
            console.log('Event Details changed: ', newVal, ' | was: ', oldVal);
            if (newVal != '') {
                this.itemType = '';
                if (this.eventItem.job) {
                  console.log("Show Job " + this.eventItem.job);
                  this.itemType = 'job';
                  this.image1 = this.getHost() + 'job/' + this.eventItem.job + '/thumb1.png';
                  this.image2 = this.getHost() + 'job/' + this.eventItem.job + '/thumb2.png';
                  this.resultsImage = this.getHost() + 'job/' + this.eventItem.job + '/vectors.png';
                  this.resultsCSV = this.getHost() + 'job/' + this.eventItem.job + '/vectors.csv';
                  this.loadMetaData();
                  this.dialog = true;
                } else if (this.eventItem.name == 'contact') {
                  console.log("Show Contact Us " + this.eventItem.meta);
                  this.itemType = 'contact';
                  this.metadata = this.eventItem.meta
                  this.dialog = true;
                }
            }
        }
    }
  }
</script>
